<script setup>
// import { watch, ref, reactive } from 'vue'
// import {
//   mdiEyeOutline,
//   mdiArrowRightBoldHexagonOutline,
//   mdiCartArrowDown,
//   mdiCartCheck,
//   mdiClose
// } from '@mdi/js'
import { useI18n } from 'vue-i18n'
import { parseMoney } from '@/money-options'


const { t } = useI18n()

const props = defineProps({
  doneProduct: { type: Object, required: true }
})


</script>

<template>

  <tr>
    <td :data-label="t('doneProducts.name')">
      {{ doneProduct.name }}
    </td>
    <td :data-label="t('doneProducts.amount')">
      {{ parseMoney(doneProduct.amount) }}
    </td>
  </tr>
</template>